"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTEGRATION_GUIDE_STEP = exports.MANUAL_LAST_STEP_ID = void 0;
var MANUAL_LAST_STEP_ID = 'last-step';
exports.MANUAL_LAST_STEP_ID = MANUAL_LAST_STEP_ID;
var INTEGRATION_GUIDE_STEP = {
  DEFAULT: 'default',
  CONTACT_XSOLLA: 'contact_xsolla',
  MANUAL: 'manual'
};
exports.INTEGRATION_GUIDE_STEP = INTEGRATION_GUIDE_STEP;